// Need to learn a bit more about the usuage of shadows in this UI to refine this. This is specifically for Button so far.

export const Shadows = {
  default: '0 4px 8px 0 rgba(36,54,71,.3)',
};
